#import "./ContractListFields.graphql"

query SearchContracts(
  $page: Int
  $limit: Int
  $search: String
  $statuses: [ContractStatusEnum!]
  $contractTypes: [ContractTypeEnum!]
  $purposes: [ContractPurposeEnum!]
  $legalEntityIds: [ID!]
  $ownerId: ID
  $teamId: ID
  $autoRenews: Boolean
  $attention: ContractAttentionEnum
) {
  searchContracts(
    page: $page
    limit: $limit
    search: $search
    statuses: $statuses
    contractTypes: $contractTypes
    purposes: $purposes
    legalEntityIds: $legalEntityIds
    ownerId: $ownerId
    teamId: $teamId
    autoRenews: $autoRenews
    attention: $attention
  ) {
    collection {
      ...ContractListFields
    }
    metadata {
      totalPages
      totalCount
      currentPage
    }
  }
}
